import { Card, CardBody, Col } from 'reactstrap'
import { MinMaxValues } from '../../../../utils/Constant'
import MinMaxValueForm from './MinMaxValueForm'
import { defaultRangeData } from '../../../../Data/BonusUi/RangeSlider/RangeSlider'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const MinMaxValue = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={MinMaxValues} span={defaultRangeData}/>
        <CardBody>
          <MinMaxValueForm />
        </CardBody>
      </Card>
    </Col>
  )
}

export default MinMaxValue